import uuid from "uuid-random";

const BROWSER_TAB_ID_KEY = "browserTabId";
const BROWSER_SESSION_ID_KEY = "browserSessionId";
const BROWSER_SESSION_ACCESSED_AT_KEY = "browserSessionLastAccessedAt";
const MAX_SESSION_IDLE_MILLISEC = 15 * 60 * 1000; // 15 minutes

export function getBrowserTabId() {
  // This generates a unique id per tab, and persists until the tab is closed.
  // For browserTabId, we don't need to track the time since last accessed
  // That information is already taken into account by browserSessionId
  let browserTabId = window.sessionStorage.getItem(BROWSER_TAB_ID_KEY);
  if (!browserTabId) {
    browserTabId = uuid();
    window.sessionStorage.setItem(BROWSER_TAB_ID_KEY, browserTabId);
  }
  return browserTabId;
}

export function getBrowserSessionId() {
  // This tracks a "sessionId" per browser. When user isn't interact with the
  // app for 15 minutes, it's counted as a different session.
  // TODO expore BrowerStorage wrapper that the LP team wrote
  // it provides an in-memory storage and handle some potential errors with localStorage
  let browserSessionId = window.localStorage.getItem(BROWSER_SESSION_ID_KEY);
  const lastAccessedAt = window.localStorage.getItem(
    BROWSER_SESSION_ACCESSED_AT_KEY,
  );
  const accessedAt = Date.now();

  if (
    !browserSessionId ||
    !lastAccessedAt ||
    accessedAt - parseInt(lastAccessedAt, 10) > MAX_SESSION_IDLE_MILLISEC
  ) {
    // generate a new id!
    browserSessionId = uuid();
    window.localStorage.setItem(BROWSER_SESSION_ID_KEY, browserSessionId);
  }

  window.localStorage.setItem(
    BROWSER_SESSION_ACCESSED_AT_KEY,
    accessedAt.toString(),
  );
  return browserSessionId;
}
